import API from 'utils/api';
import getFormattedValues, { formatReceived } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/catalogos/cuotas-fijas-para-vehiculos/';

/**
 * GET Cuotas Fijas para Vehiculos
 * @returns {Promise<Array<object>>}
 */
export const getCuotasFijas = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Cuota Fija para Vehiculo
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getCuotaFija = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Cuota Fija para Vehiculo
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCuotaFija = async (values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.post(baseURI, formattedValues);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Cuota Fija para Vehiculo
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCuotaFija = async (id, values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.patch(`${baseURI}${id}`, formattedValues);
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Cuota Fija para Vehiculo
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteCuotaFija = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
